
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ejklusxvfzsqhpuvvmxp.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVqa2x1c3h2ZnpzcWhwdXZ2bXhwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzc2NzYxMDMsImV4cCI6MjA1MzI1MjEwM30.NvOCAILT_frhBP7gy7nJpzQdbt5xEEIJpPsBXVhK0a4";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);

// Export types for use in components
export type Profile = Database['public']['Tables']['profiles']['Row'];
export type Category = Database['public']['Tables']['categories']['Row'];
export type BaseExpense = Database['public']['Tables']['expenses']['Row'];
export type Organization = Database['public']['Tables']['organizations']['Row'];
export type OrganizationMember = Database['public']['Tables']['organization_members']['Row'];

// Extended expense type with joined data
export type Expense = BaseExpense & {
  profiles?: Profile | null;
  categories?: Category | null;
  expense_report?: {
    id: string;
    status: string;
  } | null;
  is_report_summary?: boolean; // Added to identify report summary entries
};

// Email settings interface
export interface EmailSettings {
  emailProvider: "gmail" | "office365" | "smtp";
  email: string;
  password?: string;
  host?: string;
  port?: string;
  defaultRecipients: string;
}

// Extended email settings to include a name and isDefault flag
export interface ExtendedEmailSettings extends EmailSettings {
  name: string;
  isDefault?: boolean;
}
